export default "__VITE_ASSET__568d55e4__"